import { HelperFunctions } from "./HelperFunctions.js";
import { VINHelper } from "./helpers/VIN.js";

export function getResponseErrorMessages(resp) {
  let messages;
  if (resp) {
    if (resp.errorMessages) messages = resp.errorMessages;
    else if (resp.messages) messages = resp.messages;
    else if (resp.Message) messages = resp.Message;
    else if (resp.data && resp.data.errorMessages)
      messages = resp.data.errorMessages;
    else if (resp.data && resp.data.messages) messages = resp.data.messages;
    else if (resp.data && resp.data.Message) messages = resp.data.Message;
    else if (
      resp.response &&
      resp.response.data &&
      resp.response.data.errorMessages
    )
      messages = resp.response.data.errorMessages;
    else if (resp.response && resp.response.data && resp.response.data.messages)
      messages = resp.response.data.messages;
    else if (resp.response && resp.response.data && resp.response.data.Message)
      messages = resp.response.data.Message;
  }

  if (Array.isArray(messages) && messages.length === 0) messages = undefined;
  if (messages && !Array.isArray(messages)) messages = [messages];
  return messages;
}

export function arrayToObj(arr, key = "id", conversionFn = n => n) {
  if (!Array.isArray(arr)) {
    console.warn("Invalid array passed to arrayToObj... Exiting.");
    return {};
  }
  if (typeof conversionFn !== "function") {
    console.warn("Invalid conversionFn passed to arrayToObj... Exiting.");
    return {};
  }

  return arr.reduce((prev, curr) => {
    prev[conversionFn(curr[key])] = curr;
    return prev;
  }, {});
}
const ID_STR_RE = /[^A-Za-z0-9-_:]/g;
export function cleanIdString(str) {
  if (typeof str !== "string") return undefined;
  return str.toLowerCase().replace(ID_STR_RE, "-");
}

export function exists(e) {
  return (
    e !== undefined && e !== null && !(typeof e === "string" && e.trim() === "")
  );
}

export function convertIdToMotoKind(id) {
  if (!id || id.length === 0) {
    return "";
  }

  return id.replace(/-/g, ":");
}

export function convertIdToPubNubKind(id) {
  if (!id || id.length === 0) {
    return "";
  }

  return id.replace(/:/g, "-");
}

export function arraymove(arr, fromIndex, toIndex) {
  var element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
}

export function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
}

export function convertMoney(money) {
  if (!money)
    return;
  money = parseFloat(money);
  let firstConvert = money.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  return "$" + firstConvert;
}
export function convertMoneyNoDecimal(money) {
  money = parseFloat(money);
  let firstConvert = money.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  return "$" + firstConvert;
}

export function convertNumberNoDecimal(number) {
  if (number == 0) {
    return 0;
  }
  if (number && !isNaN(number)) {
    number = parseFloat(number);

    return number.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
}
export function hashCode(str) {
  var hash = 0;
  if (!str || str.length == 0) return hash;
  for (var i = 0; i < str.length; i++) {
    var char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
}

export function deepCopy(Obj) {
  return JSON.parse(JSON.stringify(Obj));
}

export function sortType(type) {
  type.sort(function (a, b) {
    const nameA = a.name.toLowerCase();
    const nameB = b.name.toLowerCase();
    let comparison = 0;
    if (nameA < nameB) {
      comparison = -1;
    } else if (nameA > nameB) {
      comparison = 1;
    }
    return comparison;
  });
}

export function rets(n) {
  if (n > 1) {
    return "s";
  }
  return "";
}

//This method generates pagination list items
//Currently generates a max of 5 items; Will be optimized later to generate 'n' items
export function generatePagingList(totalPages, currentPage) {
  let pages = [];
  try {
    if (totalPages > 1) {
      pages = [
        currentPage - 2,
        currentPage - 1,
        currentPage,
        currentPage + 1,
        currentPage + 2
      ];

      if (currentPage == 0 || currentPage == 1) pages.push(currentPage + 3);
      if (currentPage == 0) pages.push(currentPage + 4);
      if (currentPage == totalPages - 1 || currentPage == totalPages - 2)
        pages.splice(0, 0, currentPage - 3);
      if (currentPage == totalPages - 1) pages.splice(0, 0, currentPage - 4);

      pages = pages.filter(number => {
        return number >= 0 && number < totalPages;
      });
    }
  } catch (err) {
    console.log("Error generating paging list: ", err);
  }
  return pages;
}

export function arraysEqual(_arr1, _arr2) {
  if (
    !Array.isArray(_arr1) ||
    !Array.isArray(_arr2) ||
    _arr1.length !== _arr2.length
  ) {
    return false;
  }
  let arr1 = _arr1.concat().sort();
  let arr2 = _arr2.concat().sort();
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
}

export function adjustIframeHeight(iframeElement) {
  if (
    iframeElement &&
    iframeElement.contentDocument &&
    iframeElement.contentDocument.children &&
    iframeElement.contentDocument.children[0] &&
    iframeElement.contentDocument.children[0].offsetHeight > 0
  ) {
    iframeElement.style['height'] = `${iframeElement.contentDocument.children[0].offsetHeight}px`;
  }
}

export function determineSmartSearchType(searchText, hasILM) {
  searchText = (searchText || "").trim();
  
  if (HelperFunctions.validateEmail(searchText)) return "email";
  else if (HelperFunctions.validatePhoneNumber(searchText)) return "phone";
  else if (VINHelper.validateVIN(searchText)) return "vin";
  else {
    const searchWords = searchText.split(" ");
    if (searchWords.length == 1) {
      if (hasILM && HelperFunctions.validateAlphanumeric(searchText)) return "stock";
      else return "lastname";
    }
    else if (searchWords.length > 2) return "businessName"
    else return "firstAndLast";
  }
}


// WEBPACK FOOTER //
// ./src/lib/utilities/index.js